// THIS FILE IS GENERATED; DO NOT MANUALLY EDIT THIS FILE

// request imports
import type { ApiTokenCreateRequest } from '$rpc/api_token_create/request';
import type { BannerIndexRequest } from '$rpc/banner_index/request';
import type { CallbackPlaidRequest } from '$rpc/callback_plaid/request';
import type { CallbackRenderCompleteRequest } from '$rpc/callback_render_complete/request';
import type { CallbackRenderFailureRequest } from '$rpc/callback_render_failure/request';
import type { CallbackRenderPageRequest } from '$rpc/callback_render_page/request';
import type { CallbackSendgridRequest } from '$rpc/callback_sendgrid/request';
import type { CallbackStamperRequest } from '$rpc/callback_stamper/request';
import type { CallbackZipperRequest } from '$rpc/callback_zipper/request';
import type { CapitalCallSendRequest } from '$rpc/capital_call_send/request';
import type { CustomerApiFundIndexRequest } from '$rpc/customer_api_fund_index/request';
import type { CustomerApiFundShowRequest } from '$rpc/customer_api_fund_show/request';
import type { CustomerApiInvestmentIndexRequest } from '$rpc/customer_api_investment_index/request';
import type { CustomerApiInvestmentShowRequest } from '$rpc/customer_api_investment_show/request';
import type { CustomerApiInvestorIndexRequest } from '$rpc/customer_api_investor_index/request';
import type { CustomerApiInvestorShowRequest } from '$rpc/customer_api_investor_show/request';
import type { DataRoomContextRequest } from '$rpc/data_room_context/request';
import type { DataRoomDocumentDownloadUrlRequest } from '$rpc/data_room_document_download_url/request';
import type { DataRoomDocumentShowRequest } from '$rpc/data_room_document_show/request';
import type { DataRoomFolderIndexRequest } from '$rpc/data_room_folder_index/request';
import type { DataRoomNdaAcceptRequest } from '$rpc/data_room_nda_accept/request';
import type { DataRoomNdaShowRequest } from '$rpc/data_room_nda_show/request';
import type { DataRoomPeekRequest } from '$rpc/data_room_peek/request';
import type { DataRoomProspectIndicateInterestRequest } from '$rpc/data_room_prospect_indicate_interest/request';
import type { DataRoomProspectMagicLinkExchangeRequest } from '$rpc/data_room_prospect_magic_link_exchange/request';
import type { DataRoomProspectShowRequest } from '$rpc/data_room_prospect_show/request';
import type { DataRoomRequestMagicLinkRequest } from '$rpc/data_room_request_magic_link/request';
import type { DataRoomSelfRegisterRequest } from '$rpc/data_room_self_register/request';
import type { DataRoomShowRequest } from '$rpc/data_room_show/request';
import type { DataRoomViewedRequest } from '$rpc/data_room_viewed/request';
import type { DataRoomsListRequest } from '$rpc/data_rooms_list/request';
import type { InvestmentCountRequest } from '$rpc/investment_count/request';
import type { InvestorBulkEmailRequest } from '$rpc/investor_bulk_email/request';
import type { OrganizationSuspendRequest } from '$rpc/organization_suspend/request';
import type { OrganizationUnsuspendRequest } from '$rpc/organization_unsuspend/request';
import type { RequestPasswordResetRequest } from '$rpc/request_password_reset/request';
import type { UnverifiedContactIndexRequest } from '$rpc/unverified_contact_index/request';
import type { UserDisableMfaRequest } from '$rpc/user_disable_mfa/request';
import type { UserEnableMfaOtpRequest } from '$rpc/user_enable_mfa_otp/request';
import type { UserEnableMfaRequest } from '$rpc/user_enable_mfa/request';
import type { UserLoginOtpRequest } from '$rpc/user_login_otp/request';
import type { UserLoginRequest } from '$rpc/user_login/request';
import type { UserRequestPasswordResetRequest } from '$rpc/user_request_password_reset/request';
import type { UserResetPasswordRequest } from '$rpc/user_reset_password/request';
import type { UserShowRequest } from '$rpc/user_show/request';
import type { UserUpdateEmailOtpRequest } from '$rpc/user_update_email_otp/request';
import type { UserUpdateEmailRequest } from '$rpc/user_update_email/request';
import type { UserUpdateProfileRequest } from '$rpc/user_update_profile/request';
import type { VehicleOverviewListRequest } from '$rpc/vehicle_overview_list/request';
import type { VehicleOverviewQuarterListRequest } from '$rpc/vehicle_overview_quarter_list/request';
import type { VehiclePhaseUpdateRequest } from '$rpc/vehicle_phase_update/request';
import type { VehicleSuspendRequest } from '$rpc/vehicle_suspend/request';
import type { VehicleUnsuspendRequest } from '$rpc/vehicle_unsuspend/request';
import type { VersionRequest } from '$rpc/version/request';

// response imports
import type { ApiTokenCreateResponse } from '$rpc/api_token_create/response';
import type { BannerIndexResponse } from '$rpc/banner_index/response';
import type { CallbackPlaidResponse } from '$rpc/callback_plaid/response';
import type { CallbackRenderCompleteResponse } from '$rpc/callback_render_complete/response';
import type { CallbackRenderFailureResponse } from '$rpc/callback_render_failure/response';
import type { CallbackRenderPageResponse } from '$rpc/callback_render_page/response';
import type { CallbackSendgridResponse } from '$rpc/callback_sendgrid/response';
import type { CallbackStamperResponse } from '$rpc/callback_stamper/response';
import type { CallbackZipperResponse } from '$rpc/callback_zipper/response';
import type { CapitalCallSendResponse } from '$rpc/capital_call_send/response';
import type { CustomerApiFundIndexResponse } from '$rpc/customer_api_fund_index/response';
import type { CustomerApiFundShowResponse } from '$rpc/customer_api_fund_show/response';
import type { CustomerApiInvestmentIndexResponse } from '$rpc/customer_api_investment_index/response';
import type { CustomerApiInvestmentShowResponse } from '$rpc/customer_api_investment_show/response';
import type { CustomerApiInvestorIndexResponse } from '$rpc/customer_api_investor_index/response';
import type { CustomerApiInvestorShowResponse } from '$rpc/customer_api_investor_show/response';
import type { DataRoomContextResponse } from '$rpc/data_room_context/response';
import type { DataRoomDocumentDownloadUrlResponse } from '$rpc/data_room_document_download_url/response';
import type { DataRoomDocumentShowResponse } from '$rpc/data_room_document_show/response';
import type { DataRoomFolderIndexResponse } from '$rpc/data_room_folder_index/response';
import type { DataRoomNdaAcceptResponse } from '$rpc/data_room_nda_accept/response';
import type { DataRoomNdaShowResponse } from '$rpc/data_room_nda_show/response';
import type { DataRoomPeekResponse } from '$rpc/data_room_peek/response';
import type { DataRoomProspectIndicateInterestResponse } from '$rpc/data_room_prospect_indicate_interest/response';
import type { DataRoomProspectMagicLinkExchangeResponse } from '$rpc/data_room_prospect_magic_link_exchange/response';
import type { DataRoomProspectShowResponse } from '$rpc/data_room_prospect_show/response';
import type { DataRoomRequestMagicLinkResponse } from '$rpc/data_room_request_magic_link/response';
import type { DataRoomSelfRegisterResponse } from '$rpc/data_room_self_register/response';
import type { DataRoomShowResponse } from '$rpc/data_room_show/response';
import type { DataRoomViewedResponse } from '$rpc/data_room_viewed/response';
import type { DataRoomsListResponse } from '$rpc/data_rooms_list/response';
import type { InvestmentCountResponse } from '$rpc/investment_count/response';
import type { InvestorBulkEmailResponse } from '$rpc/investor_bulk_email/response';
import type { OrganizationSuspendResponse } from '$rpc/organization_suspend/response';
import type { OrganizationUnsuspendResponse } from '$rpc/organization_unsuspend/response';
import type { RequestPasswordResetResponse } from '$rpc/request_password_reset/response';
import type { UnverifiedContactIndexResponse } from '$rpc/unverified_contact_index/response';
import type { UserDisableMfaResponse } from '$rpc/user_disable_mfa/response';
import type { UserEnableMfaOtpResponse } from '$rpc/user_enable_mfa_otp/response';
import type { UserEnableMfaResponse } from '$rpc/user_enable_mfa/response';
import type { UserLoginOtpResponse } from '$rpc/user_login_otp/response';
import type { UserLoginResponse } from '$rpc/user_login/response';
import type { UserRequestPasswordResetResponse } from '$rpc/user_request_password_reset/response';
import type { UserResetPasswordResponse } from '$rpc/user_reset_password/response';
import type { UserShowResponse } from '$rpc/user_show/response';
import type { UserUpdateEmailOtpResponse } from '$rpc/user_update_email_otp/response';
import type { UserUpdateEmailResponse } from '$rpc/user_update_email/response';
import type { UserUpdateProfileResponse } from '$rpc/user_update_profile/response';
import type { VehicleOverviewListResponse } from '$rpc/vehicle_overview_list/response';
import type { VehicleOverviewQuarterListResponse } from '$rpc/vehicle_overview_quarter_list/response';
import type { VehiclePhaseUpdateResponse } from '$rpc/vehicle_phase_update/response';
import type { VehicleSuspendResponse } from '$rpc/vehicle_suspend/response';
import type { VehicleUnsuspendResponse } from '$rpc/vehicle_unsuspend/response';
import type { VersionResponse } from '$rpc/version/response';

export const rpc = {
  apiTokenCreate: 'api_token_create',
  bannerIndex: 'banner_index',
  callbackPlaid: 'callback_plaid',
  callbackRenderComplete: 'callback_render_complete',
  callbackRenderFailure: 'callback_render_failure',
  callbackRenderPage: 'callback_render_page',
  callbackSendgrid: 'callback_sendgrid',
  callbackStamper: 'callback_stamper',
  callbackZipper: 'callback_zipper',
  capitalCallSend: 'capital_call_send',
  customerApiFundIndex: 'customer_api_fund_index',
  customerApiFundShow: 'customer_api_fund_show',
  customerApiInvestmentIndex: 'customer_api_investment_index',
  customerApiInvestmentShow: 'customer_api_investment_show',
  customerApiInvestorIndex: 'customer_api_investor_index',
  customerApiInvestorShow: 'customer_api_investor_show',
  dataRoomContext: 'data_room_context',
  dataRoomDocumentDownloadUrl: 'data_room_document_download_url',
  dataRoomDocumentShow: 'data_room_document_show',
  dataRoomFolderIndex: 'data_room_folder_index',
  dataRoomNdaAccept: 'data_room_nda_accept',
  dataRoomNdaShow: 'data_room_nda_show',
  dataRoomPeek: 'data_room_peek',
  dataRoomProspectIndicateInterest: 'data_room_prospect_indicate_interest',
  dataRoomProspectMagicLinkExchange: 'data_room_prospect_magic_link_exchange',
  dataRoomProspectShow: 'data_room_prospect_show',
  dataRoomRequestMagicLink: 'data_room_request_magic_link',
  dataRoomSelfRegister: 'data_room_self_register',
  dataRoomShow: 'data_room_show',
  dataRoomViewed: 'data_room_viewed',
  dataRoomsList: 'data_rooms_list',
  investmentCount: 'investment_count',
  investorBulkEmail: 'investor_bulk_email',
  organizationSuspend: 'organization_suspend',
  organizationUnsuspend: 'organization_unsuspend',
  requestPasswordReset: 'request_password_reset',
  unverifiedContactIndex: 'unverified_contact_index',
  userDisableMfa: 'user_disable_mfa',
  userEnableMfa: 'user_enable_mfa',
  userEnableMfaOtp: 'user_enable_mfa_otp',
  userLogin: 'user_login',
  userLoginOtp: 'user_login_otp',
  userRequestPasswordReset: 'user_request_password_reset',
  userResetPassword: 'user_reset_password',
  userShow: 'user_show',
  userUpdateEmail: 'user_update_email',
  userUpdateEmailOtp: 'user_update_email_otp',
  userUpdateProfile: 'user_update_profile',
  vehicleOverviewList: 'vehicle_overview_list',
  vehicleOverviewQuarterList: 'vehicle_overview_quarter_list',
  vehiclePhaseUpdate: 'vehicle_phase_update',
  vehicleSuspend: 'vehicle_suspend',
  vehicleUnsuspend: 'vehicle_unsuspend',
  version: 'version',
} as const;

export interface RpcRequestMap {
  [rpc.apiTokenCreate]: ApiTokenCreateRequest;
  [rpc.bannerIndex]: BannerIndexRequest;
  [rpc.callbackPlaid]: CallbackPlaidRequest;
  [rpc.callbackRenderComplete]: CallbackRenderCompleteRequest;
  [rpc.callbackRenderFailure]: CallbackRenderFailureRequest;
  [rpc.callbackRenderPage]: CallbackRenderPageRequest;
  [rpc.callbackSendgrid]: CallbackSendgridRequest;
  [rpc.callbackStamper]: CallbackStamperRequest;
  [rpc.callbackZipper]: CallbackZipperRequest;
  [rpc.capitalCallSend]: CapitalCallSendRequest;
  [rpc.customerApiFundIndex]: CustomerApiFundIndexRequest;
  [rpc.customerApiFundShow]: CustomerApiFundShowRequest;
  [rpc.customerApiInvestmentIndex]: CustomerApiInvestmentIndexRequest;
  [rpc.customerApiInvestmentShow]: CustomerApiInvestmentShowRequest;
  [rpc.customerApiInvestorIndex]: CustomerApiInvestorIndexRequest;
  [rpc.customerApiInvestorShow]: CustomerApiInvestorShowRequest;
  [rpc.dataRoomContext]: DataRoomContextRequest;
  [rpc.dataRoomDocumentDownloadUrl]: DataRoomDocumentDownloadUrlRequest;
  [rpc.dataRoomDocumentShow]: DataRoomDocumentShowRequest;
  [rpc.dataRoomFolderIndex]: DataRoomFolderIndexRequest;
  [rpc.dataRoomNdaAccept]: DataRoomNdaAcceptRequest;
  [rpc.dataRoomNdaShow]: DataRoomNdaShowRequest;
  [rpc.dataRoomPeek]: DataRoomPeekRequest;
  [rpc.dataRoomProspectIndicateInterest]: DataRoomProspectIndicateInterestRequest;
  [rpc.dataRoomProspectMagicLinkExchange]: DataRoomProspectMagicLinkExchangeRequest;
  [rpc.dataRoomProspectShow]: DataRoomProspectShowRequest;
  [rpc.dataRoomRequestMagicLink]: DataRoomRequestMagicLinkRequest;
  [rpc.dataRoomSelfRegister]: DataRoomSelfRegisterRequest;
  [rpc.dataRoomShow]: DataRoomShowRequest;
  [rpc.dataRoomViewed]: DataRoomViewedRequest;
  [rpc.dataRoomsList]: DataRoomsListRequest;
  [rpc.investmentCount]: InvestmentCountRequest;
  [rpc.investorBulkEmail]: InvestorBulkEmailRequest;
  [rpc.organizationSuspend]: OrganizationSuspendRequest;
  [rpc.organizationUnsuspend]: OrganizationUnsuspendRequest;
  [rpc.requestPasswordReset]: RequestPasswordResetRequest;
  [rpc.unverifiedContactIndex]: UnverifiedContactIndexRequest;
  [rpc.userDisableMfa]: UserDisableMfaRequest;
  [rpc.userEnableMfaOtp]: UserEnableMfaOtpRequest;
  [rpc.userEnableMfa]: UserEnableMfaRequest;
  [rpc.userLoginOtp]: UserLoginOtpRequest;
  [rpc.userLogin]: UserLoginRequest;
  [rpc.userRequestPasswordReset]: UserRequestPasswordResetRequest;
  [rpc.userResetPassword]: UserResetPasswordRequest;
  [rpc.userShow]: UserShowRequest;
  [rpc.userUpdateEmailOtp]: UserUpdateEmailOtpRequest;
  [rpc.userUpdateEmail]: UserUpdateEmailRequest;
  [rpc.userUpdateProfile]: UserUpdateProfileRequest;
  [rpc.vehicleOverviewList]: VehicleOverviewListRequest;
  [rpc.vehicleOverviewQuarterList]: VehicleOverviewQuarterListRequest;
  [rpc.vehiclePhaseUpdate]: VehiclePhaseUpdateRequest;
  [rpc.vehicleSuspend]: VehicleSuspendRequest;
  [rpc.vehicleUnsuspend]: VehicleUnsuspendRequest;
  [rpc.version]: VersionRequest;
}

export interface RpcResponseMap {
  [rpc.apiTokenCreate]: ApiTokenCreateResponse;
  [rpc.bannerIndex]: BannerIndexResponse;
  [rpc.callbackPlaid]: CallbackPlaidResponse;
  [rpc.callbackRenderComplete]: CallbackRenderCompleteResponse;
  [rpc.callbackRenderFailure]: CallbackRenderFailureResponse;
  [rpc.callbackRenderPage]: CallbackRenderPageResponse;
  [rpc.callbackSendgrid]: CallbackSendgridResponse;
  [rpc.callbackStamper]: CallbackStamperResponse;
  [rpc.callbackZipper]: CallbackZipperResponse;
  [rpc.capitalCallSend]: CapitalCallSendResponse;
  [rpc.customerApiFundIndex]: CustomerApiFundIndexResponse;
  [rpc.customerApiFundShow]: CustomerApiFundShowResponse;
  [rpc.customerApiInvestmentIndex]: CustomerApiInvestmentIndexResponse;
  [rpc.customerApiInvestmentShow]: CustomerApiInvestmentShowResponse;
  [rpc.customerApiInvestorIndex]: CustomerApiInvestorIndexResponse;
  [rpc.customerApiInvestorShow]: CustomerApiInvestorShowResponse;
  [rpc.dataRoomContext]: DataRoomContextResponse;
  [rpc.dataRoomDocumentDownloadUrl]: DataRoomDocumentDownloadUrlResponse;
  [rpc.dataRoomDocumentShow]: DataRoomDocumentShowResponse;
  [rpc.dataRoomFolderIndex]: DataRoomFolderIndexResponse;
  [rpc.dataRoomNdaAccept]: DataRoomNdaAcceptResponse;
  [rpc.dataRoomNdaShow]: DataRoomNdaShowResponse;
  [rpc.dataRoomPeek]: DataRoomPeekResponse;
  [rpc.dataRoomProspectIndicateInterest]: DataRoomProspectIndicateInterestResponse;
  [rpc.dataRoomProspectMagicLinkExchange]: DataRoomProspectMagicLinkExchangeResponse;
  [rpc.dataRoomProspectShow]: DataRoomProspectShowResponse;
  [rpc.dataRoomRequestMagicLink]: DataRoomRequestMagicLinkResponse;
  [rpc.dataRoomSelfRegister]: DataRoomSelfRegisterResponse;
  [rpc.dataRoomShow]: DataRoomShowResponse;
  [rpc.dataRoomViewed]: DataRoomViewedResponse;
  [rpc.dataRoomsList]: DataRoomsListResponse;
  [rpc.investmentCount]: InvestmentCountResponse;
  [rpc.investorBulkEmail]: InvestorBulkEmailResponse;
  [rpc.organizationSuspend]: OrganizationSuspendResponse;
  [rpc.organizationUnsuspend]: OrganizationUnsuspendResponse;
  [rpc.requestPasswordReset]: RequestPasswordResetResponse;
  [rpc.unverifiedContactIndex]: UnverifiedContactIndexResponse;
  [rpc.userDisableMfa]: UserDisableMfaResponse;
  [rpc.userEnableMfaOtp]: UserEnableMfaOtpResponse;
  [rpc.userEnableMfa]: UserEnableMfaResponse;
  [rpc.userLoginOtp]: UserLoginOtpResponse;
  [rpc.userLogin]: UserLoginResponse;
  [rpc.userRequestPasswordReset]: UserRequestPasswordResetResponse;
  [rpc.userResetPassword]: UserResetPasswordResponse;
  [rpc.userShow]: UserShowResponse;
  [rpc.userUpdateEmailOtp]: UserUpdateEmailOtpResponse;
  [rpc.userUpdateEmail]: UserUpdateEmailResponse;
  [rpc.userUpdateProfile]: UserUpdateProfileResponse;
  [rpc.vehicleOverviewList]: VehicleOverviewListResponse;
  [rpc.vehicleOverviewQuarterList]: VehicleOverviewQuarterListResponse;
  [rpc.vehiclePhaseUpdate]: VehiclePhaseUpdateResponse;
  [rpc.vehicleSuspend]: VehicleSuspendResponse;
  [rpc.vehicleUnsuspend]: VehicleUnsuspendResponse;
  [rpc.version]: VersionResponse;
}
